export enum AddUSerFormActionTypes {
  SHOW_ADD_USER_FORM = 'SHOW_ADD_USER_FORM',
  HIDE_ADD_USER_FORM = 'HIDE_ADD_USER_FORM',
  START_USER_DATA_LOADING = 'START_USER_DATA_LOADING',
  END_USER_DATA_LOADING = 'END_USER_DATA_LOADING',
  ADD_USER_ERROR_DATA = 'ADD_USER_ERROR_DATA',
  ADD_USER_DATA_CLEANUP = 'ADD_USER_DATA_CLEANUP',
}
